async function getEntitlements(ents) {

    var json = {
        entitlements: ents,
    };

    try {
        var response = await fetch("https://tanki.su/wotup/claim_product/get_inventory_entitlements/", {
        // var response = await fetch("http://localhost:3009/get_inventory_entitlements/", {
            method: "POST",
            body: JSON.stringify(json)
        })
        var result = await response.json();
        return result;
    } catch (error) {
        return [];
    }
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function generateResultHTML(el, data) {
    const content = el.querySelector('.ca-block__content');

    const amount = data?.data[0]?.amount ? data.data[0].amount : 0;

    const awardsItem = _awards.map((award, i) => {
        return `
            <div class="ca-awards__item ${ (i + 1) <= amount ? 'active' : '' }">
                <img src="${award.image}" alt="${award.title}" />
                <p>${award.title}</p>
                <span>${award.count}</span>
            </div>`
    }).join("\n")

    const awards = `
        <p class="ca-title">Твоя награда за участие</p>
        <div class="ca-awards">
            ${awardsItem}
        </div>
    `;

    content.innerHTML = awards;
}

function generateNotAuthHTML(el) {
    const content = el.querySelector('.ca-block__content');
    content.innerHTML = `
        <p class="ca-title">ПРОВЕРЬ СВОЕ УЧАСТИЕ</p>
        <a href="https://tanki.su/auth/oid/new/?next=${window.location.pathname}" class="cta-button">Войти</a>
    `
}

async function initAwards() {

    const widget = document.querySelector('.ca-block');

    if (window.is_auth_user()) {
        const ents = widget.getAttribute('data-ents').split(",");

        const response = await getEntitlements(ents);

        generateResultHTML(widget, response)
    } else {
        generateNotAuthHTML(widget);
    }
}

window.addEventListener('load', function () {
    initAwards();
})